import React from 'react';

export default () => (
    <div className='nav-left'></div>
)